var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status.text),expression:"status.text"}],class:_vm.statusClassName,domProps:{"textContent":_vm._s(_vm.status.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }